import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const OurClients = () => {
  const [visibleRows, setVisibleRows] = useState([]);
  const companies = [
    {name: 'Persistent Systems', logo: '/clients/Persistent.png'},
    { name: 'iASYS Technology Pvt Ltd', logo: '/clients/IASYS TECHNOLOGY PVT LTD.png' },
    { name: 'Amphenol Socapex Ltd', logo: '/clients/AMPHENOL SOCAPEX LTD.png' },
    { name: 'TransPerfect Solution Pvt Ltd', logo: '/clients/TRANSPERFECT SOLUTION PVT LTD.png' },
    { name: 'Paybook', logo: '/clients/Paybook.jpg'},
    { name: 'TransImpact Pvt Ltd', logo: '/clients/TRANSLMPACT PVT LTD.png' },
    { name: 'EduSpace Inc', logo: '/clients/EDUSPACE INC.png' },
    { name: 'Aqua Tech Pvt Ltd', logo: '/clients/AQUA TECH PVT LTD.png' },
    { name: 'Gamreji Hinjewadi', logo: '/clients/GAMREJI HINJEWADI.png' },
    { name: 'ING Enterprises', logo: '/clients/ING.png' },
    { name: 'GNS Engineering Services', logo: '/clients/GNS ENGINEERING SERVICES.png' },
    { name: 'Alecrity Engineering', logo: '/clients/Alacrity.png' },
    { name: 'Fitwell Gas Kit Pvt Ltd', logo: '/clients/FITWELL GAS KIT PVT LTD.png' },
    { name: 'Matrics Solutions Pvt Ltd', logo: '/clients/MATRICS SOLUTIONS PVT LTD.png' },
    { name: 'GEFIT Technologies Pvt Ltd', logo: '/clients/GEFIT TECHNOLOGIES PVT LTD.png' },
    { name: 'HNB Equipment Pvt Ltd', logo: '/clients/HNB EQUIPMENT PVT LTD.png' },
    { name: 'DeltaFlow Solutions Pvt Ltd', logo: '/clients/DELTAFLOW SOLUTIONS PVT LTD.png' },
    { name: 'Kinetic Electric Motor Co. Pvt Ltd', logo: '/clients/KINETIC ELECTRIC MOTOR.CO.PVT LTD.png' },
    { name: 'Camlot IT Lab Pvt Ltd', logo: '/clients/CAMLOT IT LAB PVT LTD.png' },
    { name: 'Autocomp Corporation Panase Pvt Ltd', logo: '/clients/AUTOCOMP CORPORATION PANASE PVT LTD.png' },
    { name: 'Hikal Ltd', logo: '/clients/HIKAL LTD.png' },
    { name: 'JPM Industries Limited', logo: '/clients/JPM INDUSTRIES LIMITED.png' },
    { name: 'Shriram Rubber Product Pvt Ltd', logo: '/clients/SHRIRAM RUBBER PRODDUCT PVT LTD.png' },
    { name: 'Greek Soft Technologies Pvt Ltd', logo: '/clients/GREEK SOFT TECHNOLOGIES PVT LTD.png' },
  ];

  const rows = [];
  for (let i = 0; i < companies.length; i += 6) {
    rows.push(companies.slice(i, i + 6));
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    // Show each row with a delay one-by-one ONCE
    rows.forEach((_, index) => {
      setTimeout(() => {
        setVisibleRows((prev) => [...prev, index]);
      }, index * 1000); // 1s delay between rows
    });
  }, []);

  return (
    <section
      className="bg-white py-16 px-6 md:px-12 lg:px-20 relative min-h-screen"
      style={{
        backgroundImage: `url('/clients/client-bg.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black/30 z-0"></div>

      <div className="relative z-10">
        <h2 className="text-5xl font-bold text-center text-white mb-10">
          Our <span className="text-7xl text-sky-400"> Clients </span>
        </h2>

        <div className="mt-40 mb-16 max-w-10xl">
          <p className="text-2xl text-white text-left">
            We are privileged to work with a diverse range of companies—from innovative IT labs to leading engineering firms.
            Here are some of the partners who trust us to deliver exceptional solutions and drive their businesses forward.
          </p>
        </div>

        <div className="flex flex-col gap-10">
          {rows.map((row, rowIndex) => (
            <AnimatePresence key={rowIndex}>
              {visibleRows.includes(rowIndex) && (
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.8 }}
                  className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-10"
                >
                  {row.map((company, i) => (
                    <div
                      key={i}
                      className="flex justify-center items-center h-28 p-4 bg-stone-400 rounded-xl shadow-md hover:shadow-lg transition"
                    >
                      <img
                        src={company.logo}
                        alt={company.name}
                        className="max-h-20 w-auto object-contain"
                      />
                    </div>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurClients;
